import type { HelpFile } from '../../types/help'
import { FieldCardTestIds } from '../../../testids/FieldCardTestIds'

export const fieldCardHelp: HelpFile = {
  docPage: '/docs/admin/form-layouts',
  texts: {
    [FieldCardTestIds.fieldCardRemoveBtn]: 'Dieses Feld aus dem Layout entfernen — die Attributdefinition selbst bleibt erhalten.',
  },
}
